// session.js (or inside your config file)
export function initSession() {
  if (!localStorage.getItem("randomNumber")) {
    const min = 10000;
    const max = 99999;
    const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
    console.log("----- random number ----->", randomNumber);
    localStorage.setItem("randomNumber", randomNumber);
  }

  let sessionTime = localStorage.getItem("sessionTime") || "";
  let sessionId = localStorage.getItem("sessionId") || "";

  if (sessionTime && sessionId && Date.now() - sessionTime > 300000) { // 5 minutes
    console.log("----- session id updated : --->" + Date.now() + "" + localStorage.getItem("randomNumber"));
    const newSessionId = Date.now() + "" + localStorage.getItem("randomNumber");
    localStorage.setItem("sessionId", newSessionId);
    localStorage.setItem("user_type", "repeatedUser");
    sessionId = newSessionId;
  }

  localStorage.setItem("sessionTime", Date.now());

  if (!sessionId) {
    sessionId = Date.now() + "" + localStorage.getItem("randomNumber");
    localStorage.setItem("sessionId", sessionId);
  }

  return sessionId;
}